import { getStateAtNamespaceKey } from 'redux/get-state-at-namespace-key';

export const getGreenSlotsVariant = (state: WtrState) =>
  getStateAtNamespaceKey(state, 'slots').greenVariant;
